<div *ngIf="!showOnlyBar">

    <div *ngIf="dataSource.data.value.length === 0"
         class="legend">
        {{ emptyMessage | translate }}
    </div>
    <mat-table *ngIf="dataSource.data.value.length > 0"
               [dataSource]="dataSource">
        <mat-header-row *matHeaderRowDef="tableColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: tableColumns">
        </mat-row>
        <ng-container matColumnDef="image">
            <mat-header-cell *matHeaderCellDef
                             class="image-cell hideable-500"
                             [class.hidden]="!hasImage">
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index"
                      class="image-cell hideable-500"
                      [class.hidden]="!hasImage">
                <img *ngIf="row.row.image"
                     [src]="conf.storageRootUrl + row.row.image"
                     [class.circle]="isImageCircle" />
                <mat-icon *ngIf="!row.row.image && imageFallbackIcon">
                    {{ imageFallbackIcon }}
                </mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef
                             class="name-cell">
                {{ 'Name' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index"
                      class="name-cell">
                <div class="title">
                    {{ row.row.title }}
                </div>
                <div *ngIf="row.row.subTitle"
                     class="sub-title">
                    {{ row.row.subTitle }}
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef
                             class="value-cell">
                {{ valueColumnName | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index"
                      class="value-cell">
                {{ row.value }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="chart">
            <mat-header-cell *matHeaderCellDef>
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index">
                {{row.id}}
                <div class="bar-container"
                     [style.width]="row.share + '%'">
                    <div *ngFor="let item of row.columns"
                         class="bar-item"
                         [style.width]="item.share + '%'"
                         [style.background-color]="item.column.color"
                         [matTooltip]="item.column.title + ' [' + item.value.value + ']'">
                    </div>
                </div>
            </mat-cell>
        </ng-container>
    </mat-table>

</div>

<div *ngIf="showOnlyBar">

    <div *ngFor="let row of rawData">
        <div class="bar-container">
            <div *ngFor="let item of row.columns"
                 class="bar-item"
                 [style.width]="item.share + '%'"
                 [style.background-color]="item.column.color"
                 [matTooltip]="item.column.title + ' [' + (item.value.value | number:'1.0-1') + ']'">
            </div>
        </div>
    </div>

</div>
